import SubAccountForm from "./SubAccountForm";
import type { SubAccount } from "src/types/customer";

interface AddSubAccountWithParentProps {
	/** Only supplied when editing an existing record. */
	subAccount?: SubAccount;
}

/** Add or edit a sub account from the Sub Accounts page, where the parent customer is picked in the form. */
const AddSubAccountWithParent = ({ subAccount }: AddSubAccountWithParentProps) => (
	<SubAccountForm subAccount={subAccount} pickParent invalidateKey="subAccounts" />
);

export default AddSubAccountWithParent;
